import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { EyeIcon, SmartphoneIcon, ArrowRightIcon, GiftIcon, CheckCircleIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://www.tumomentovital.com/cart/47625937879232:1';
export function HookSection() {
  return <SectionWrapper className="bg-cyber-dark/50 border-y border-cyber-neon/10" data-id="element-329">
      <div className="text-center mb-10" data-id="element-330">
        <h2 className="text-2xl md:text-4xl text-white mb-4" data-id="element-331">
          ¿Alguna vez has sentido ese{' '}
          <span className="text-cyber-red" data-id="element-332">vacío en el estómago</span> al entrar
          a un lugar lleno de gente?
        </h2>
      </div>

      <div className="space-y-5 text-gray-300 text-lg" data-id="element-333">
        <p className="flex items-start gap-4" data-id="element-334">
          <EyeIcon className="w-7 h-7 text-cyber-purple shrink-0 mt-1" data-id="element-335" />
          <span data-id="element-336">
            Esa sensación de que todos los ojos están puestos en ti, analizando
            cómo caminas, qué ropa traes y lo "raro" que te ves.
          </span>
        </p>
        <p className="flex items-start gap-4" data-id="element-337">
          <SmartphoneIcon className="w-7 h-7 text-cyber-purple shrink-0 mt-1" data-id="element-338" />
          <span data-id="element-339">
            Te quedas pegado al celular con la pantalla apagada solo para
            parecer ocupado. Quieres hablar, quieres conectar, pero tu garganta
            se cierra y tu cerebro se pone en blanco.
          </span>
        </p>

        <div className="p-6 border-l-4 border-cyber-neon bg-cyber-neon/5 rounded-r-lg" data-id="element-340">
          <p className="text-xl font-mono text-white m-0" data-id="element-341">
            <strong className="text-cyber-neon" data-id="element-342">
              No eres raro, y no estás roto.
            </strong>{' '}
            Simplemente estás operando con un software social desactualizado.
            Pero eso se termina hoy.
          </p>
        </div>

        <div className="text-center pt-4 flex flex-col items-center gap-2" data-id="element-343">
          <NeonButton href={CHECKOUT_URL} variant="secondary" size="md" data-id="element-344">
            Empieza tu transformación por $9.99{' '}
            <ArrowRightIcon className="w-4 h-4" data-id="element-345" />
          </NeonButton>
          <span className="flex items-center gap-1.5 text-[11px] font-mono bg-cyber-neon/5 border border-cyber-neon/30 rounded-full px-3 py-1.5 shadow-[0_0_8px_rgba(57,255,20,0.1)]" data-id="element-346">
            <GiftIcon className="w-3 h-3 text-cyber-neon animate-pulse" data-id="element-347" />
            <span className="text-gray-300" data-id="element-348">
              + 2 Bonos <strong className="text-cyber-neon" data-id="element-349">GRATIS</strong>{' '}
              incluidos <span className="text-gray-500" data-id="element-350">(valor $47)</span>
            </span>
          </span>
          <div className="bg-cyber-dark/60 border border-cyber-neon/15 rounded-lg p-2.5 space-y-1.5 w-full max-w-md" data-id="element-351">
            <div className="flex items-start gap-2" data-id="element-352">
              <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-353" />
              <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-354">
                <span className="text-gray-300 font-bold" data-id="element-355">Bonus 1:</span>{' '}
                Scripts de Supervivencia en Citas — qué decir para que nunca
                haya silencios incómodos.
                <span className="ml-1 text-gray-500 line-through" data-id="element-356">$25</span>
                <span className="ml-1 text-cyber-neon font-bold" data-id="element-357">GRATIS</span>
              </p>
            </div>
            <div className="flex items-start gap-2" data-id="element-358">
              <CheckCircleIcon className="w-3.5 h-3.5 text-cyber-neon shrink-0 mt-0.5" data-id="element-359" />
              <p className="text-[10px] font-mono text-gray-400 leading-tight" data-id="element-360">
                <span className="text-gray-300 font-bold" data-id="element-361">Bonus 2:</span>{' '}
                Templates de Texto Irresistibles — para que nunca más te dejen
                en "visto" en WhatsApp.
                <span className="ml-1 text-gray-500 line-through" data-id="element-362">$22</span>
                <span className="ml-1 text-cyber-neon font-bold" data-id="element-363">GRATIS</span>
              </p>
            </div>
            <div className="border-t border-cyber-neon/20 pt-1.5 mt-1" data-id="element-364">
              <p className="text-[11px] font-mono text-cyber-neon font-bold text-center" data-id="element-365">
                Te ahorras $47 USD en bonos de regalo
              </p>
            </div>
          </div>
          <button onClick={() => document.getElementById('bonos')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-[11px] text-cyber-neon font-mono underline underline-offset-2 hover:text-white transition-colors" data-id="element-366">
            Leer más
          </button>
        </div>
      </div>
    </SectionWrapper>;
}